import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async fromModule(moduleId) {
        console.assert(typeof moduleId === "number");
        return http.get(buildUrlFromLocation(`/components/${moduleId}/related-products`));
    }
};



// WEBPACK FOOTER //
// ./src/services/product.js